export const version = `1.4.1`;
export const versionWithBuild = `1.4.1-25`;
